import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import parse from 'html-react-parser';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const FullBlueContent = () => {
    const text = [
        'Мы создали автоматический сервис по увеличению ссылочной массы для владельцев бизнеса, SEO-специалистов и агентств — Linkbuilder.Ai. Он экономит ресурсы и помогает быстро нарастить ссылочную массу сайта.',
    ];
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="bg-blue-content">
                <div className="bg-blue-content__wrapper">
                    <div className="bg-blue-content__title">
                        Как сделать этот процесс эффективнее?
                    </div>

                    <div className="bg-blue-content__desc">
                        {text.map((item, index) => {
                            return (
                                <div key={index} className="bg-blue-content__text">
                                    {parse(item)}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default FullBlueContent;
